import { inject, Injectable } from '@angular/core';
import { shareReplay, switchMap } from 'rxjs/operators';
import { StaticContentService } from './static-content.service';
import { first, Observable, of, tap } from 'rxjs';
import { filterFirst } from 'ngx-unificator/rxjs';
import { CookieMessageContentComponent } from '../shared/components/toast-message/content/cookie-message-content/cookie-message-content.component';
import { ToastMessageService } from '../shared/components/toast-message/toast-message.service';
import { CookieService, PlatformService } from 'ngx-unificator/services';

@Injectable({
  providedIn: 'root',
})
export class EpmCountryRestrictionService {
  private _static = inject(StaticContentService);
  private _toastMessage = inject(ToastMessageService);
  private _cookies = inject(CookieService);
  private _platform = inject(PlatformService);

  public text$ = this._createTextSource();
  public text = null;

  /**
   * Show message until user accepts cookies
   */
  public showCookiesMessage() {
    if (!this._platform.isBrowser) {
      return;
    }
    if (!this._cookies.check('isCookiesAccepted')) {
      this.text$
        .pipe(
          first(),
          tap(() => {
            const message = this._toastMessage.success(CookieMessageContentComponent, 'key', true, false, true, 'cookie-message');
            message.callback = () => {
              setTimeout(() => {
                if (!this._cookies.check('isCookiesAccepted')) {
                  this.showCookiesMessage();
                }
              }, 500);
            };
          }),
        )
        .subscribe();
    }
  }

  private _createTextSource(): Observable<string> {
    return this._static.item({ slug: 'emp-popup' }).pipe(
      filterFirst((res) => !!res),
      switchMap((res) => {
        if (res.length && res[0].Content) {
          this.text = res[0].Content;
        } else {
          this.text = ' ';
        }

        return of(this.text);
      }),
      shareReplay(1),
    );
  }
}
